import { z } from "zod";
import { journeyStepSchema, readJourneyStepSchema } from "./steps.js";
// GET /client/journey/support — the Asiantuntijatuki tab: the same three steps
// as the infusion tab, with booking the call with the nutrition coach last.
// The purchase is not a step: the page offers it above the card while
// assessmentPaid is false, and booking stays locked until it is true.
export const supportSurfaceSchema = z.object({
    steps: z.array(journeyStepSchema),
    assessmentPaid: z.boolean(),
});
export const readSupportSurfaceSchema = z.object({
    steps: z.array(readJourneyStepSchema),
    // An api from before this field existed: no purchase CTA rather than a
    // failed tab. Offering the purchase to someone who has paid is the worse
    // mistake of the two.
    assessmentPaid: z.boolean().catch(true),
});
